import { MapFiltersProvider } from "./filters/filterContext";
import { MapFilters } from "./filters/filters";
import { Map } from "./map";

interface Props {
	entityType?: string;
	entityId?: string;
}

export function Maps(props: Props) {
	const { entityType, entityId } = props;

	return (
		<MapFiltersProvider startingEntityType={entityType} startingEntityId={entityId}>
			<main className="grid h-[88vh] grid-cols-4 overflow-hidden">
				<section className="col-span-1 h-full overflow-auto p-4">
					<MapFilters />
				</section>
				<section className="col-span-3 h-full">
					<Map />
				</section>
			</main>
		</MapFiltersProvider>
	);
}
